import { render } from "./MSReflectionEditModal.vue?vue&type=template&id=a9071ac0&scoped=true&ts=true"
import script from "./MSReflectionEditModal.vue?vue&type=script&lang=ts"
export * from "./MSReflectionEditModal.vue?vue&type=script&lang=ts"

import "./MSReflectionEditModal.vue?vue&type=style&index=0&id=a9071ac0&lang=scss&scoped=true"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9071ac0"]])

export default __exports__